import { Prices } from '@fortem-monorepo/web-sdk'

export const queryKeys = {
  eod: {
    all: ['prices', 'eod', 'validation'] as const,
    validation: (params: Prices.GetPriceValidationParams) =>
      [...queryKeys.eod.all, params] as const,
    validationImpact: (params: Prices.GetPriceValidationParams) =>
      [...queryKeys.eod.all, 'impact', params] as const,
  },
}
